import { createApiRequest } from "../common";

/**
 * Persist a thread's read-state back to Gmail via Nylas.
 *
 * Server-only route (`POST /integrations/nylas/threads/mark-read`) — non-Smithy
 * (it's an inbox UI action, not part of the typed deal CRUD surface), so the
 * request/response shapes are declared locally to mirror the api-server handler
 * (handlers/nylas-inbox.ts → markNylasThreadRead → Nylas PUT {unread:false}).
 *
 * Without this the inbox red dot only cleared in local React state and a reload
 * re-pulled Nylas's still-unread truth. This makes the read real: Nylas
 * propagates it to the actual Gmail mailbox, so the dot stays cleared.
 */
export interface MarkThreadReadRequest {
  connectionId: string;
  externalThreadId: string;
  /** Defaults true (mark read). Pass false to mark unread. */
  read?: boolean;
}

export interface MarkThreadReadResponse {
  ok: boolean;
  unread: boolean;
}

export const markThreadReadApi = async (
  request: MarkThreadReadRequest,
): Promise<MarkThreadReadResponse> => {
  const apiRequest = createApiRequest<MarkThreadReadResponse>(
    "post",
    "/integrations/nylas/threads/mark-read",
  );
  return apiRequest(request);
};
